import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import menu_template from "ulysses/components/menu.html";
import "ulysses/controls/media";
import "ulysses/controls/iconpicker";
import "adminlte";

/*
  with thanks from: http://smellegantcode.wordpress.com/2012/12/10/asynchronous-computed-observables-in-knockout-js/
*/
ko.extenders.async = function(computedDeferred, initialValue) {

    var currentDeferred = null;
    var plainObservable = ko.observable(initialValue);
    plainObservable.inProgress = ko.observable(false);

    ko.computed(function() {
        if (currentDeferred) {
            currentDeferred.reject();
            currentDeferred = null;
        }

        var newDeferred = computedDeferred();
        if (newDeferred &&
            (typeof newDeferred.then == "function")) {

            // It's a deferred
            plainObservable.inProgress(true);

            // Create our own wrapper so we can reject
            currentDeferred = Promise.Deferred();
            currentDeferred.then(function(data) {
                plainObservable.inProgress(false);
                plainObservable(data);
            });
            newDeferred.then((res) => { currentDeferred.resolve(res); });
        } else {
            // A real value, so just publish it immediately
            plainObservable(newDeferred);
        }
    });

    return plainObservable;
};

function MenuModel(params) {
    $.extend(this, {
        "menu_spec":params.spec,
        "style":ko.pureComputed(function() {
            var result = ko.unwrap(params.style);
            if (result == "admin" || result == "top" || result=="left")
                return result;
            return "left";
        }),
        "menu":ko.pureComputed(function() {
            var result = ko.observable();
            var value = ko.unwrap(params.spec);
            if (Object.isObject(value)) {
                return value;
            } else if (!value) {
                return null;
            }
            return uly.api.start().follow("uly:app").follow(value).then(function(value) {
                value.items.forEach((v) => { v.active = ko.observable(false); } );
                value.activate = (ev,ui) => { 
                    console.log("activate:", ui, ev, ev.target);
                    value.items.forEach((v) => v.active(false));
                    ui.model.active(true);
                };
                return value;
            });
        }).extend({"async":null}),
        "init":function(elts, model) {
            if ($.AdminLTE) {
                $.AdminLTE.tree($(elts));
            } else if ($.fn.tree) {
                $(elts).tree();
            } else if ($.fn.TreeView) {
                $(elts).TreeView();
            }
            
        }
    });
}

ko.components.register("uly-menu", {
    viewModel:MenuModel,
    template: menu_template
});

ko.bindingHandlers.bsdropdown = {
    "init":function(elt) {
        $(elt).dropdown();
    }
};
